export const kds = {
	emptyKdsDescription:
		"The KDS has not been created yet. When available, it will be displayed here.",
	editKds: "Your changes have been saved.",
	title: "Manage KDS",
	subtitle: "Configure the KDS to enhance and organize your kitchen operations.",
	createdAt: "Created at",
	seeKds: "View KDS",
	linkedBar: "Linked bar",
	basic: "Basic",
	main: "Main",
	general: "Gereral",
	mainTooltip:
		"The Main KDS centralizes order control, allowing you to change statuses, cancel, view cancellations, and track all orders.",
	basicTooltip:
		"The Basic KDS displays all orders directed to it with the status open and completed, without allowing changes or viewing cancellations.",
	confirmModal: {
		title: "You have unsaved changes",
		description:
			"To leave the page without losing your progress, save your changes. If you continue without saving, all changes will be lost.",
		close: "Leave without saving",
	},
	form: {
		name: "KDS Name",
		linkedBar: "Linked bar",
		status: "Status change",
		timeManagement: "Time management",
		readyTimeOrderLabel: "Time for an order to be considered ready",
		standardTimeOrderLabel: "Standard time per order (min.)",
		originOrder: "Order origin (Delivery and other integrations)",
		orderNumber: "Order number",
		customerName: "Customer name",
		saveChanges: "Save changes",
		generalSettings: "General settings",
		timeSettings: "Time settings",
		orderCardSettings: "Order card settings",
	},
	statusChangeTypes: {
		auto: "Automatically",
		manual: "Manually",
	},
	timeManagementTypes: {
		byProduct: "Use time per product from the integration",
		defaultTime: "Use a standard per order",
		noManagement: "Do not use time",
	},
	zigKds: {
		title: "KDS Management",
		description: "Manage your KDS, link products to screens and track orders.",
		searchPlaceholder: "Search for...",
		createNew: "Create new",
		card: {
			linkedBarLabel: "Linked Bar(s):",
			linkedProductsLabel: "Linked Products",
			editButton: "Edit",
			addScreenButton: "Add Screen",
			editScreen: "Edit Screen",
			deleteScreen: "Delete Screen",
			primary: "Primary",
			secondary: "Secondary",
		},
		emptyState: {
			createNewKds: "Create a new KDS",
			title: "No KDS configured yet",
			description:
				"You don't have any KDS yet. Register and configure one to track your orders on screens.",
			noSearchResults: {
				title: "KDS not found",
				description:
					"We couldn't find any KDS with the searched terms. Try adjusting your search.",
			},
		},
		deleteScreenModal: {
			title: "Delete screen",
			confirmText:
				"Are you sure you want to <highlight>delete</highlight> the screen {{screenName}}?",
			warningText:
				"When confirmed, all products associated with this screen will be deleted.",
			cancelButton: "Back",
			confirmButton: "Confirm",
		},
		drawer: {
			createTitle: "Create new KDS",
			editTitle: "Edit KDS",
			backButton: "Back",
			saveButton: "Save",
			deleteButton: "Delete KDS",
			discardChanges: {
				title: "Discard changes?",
				subtitle: "You have unsaved changes. If you leave now, they will be discarded.",
				confirm: "Discard",
				cancel: "Keep editing",
			},
		},
		deleteKdsModal: {
			title: "Delete KDS",
			confirmText:
				"Are you sure you want to <highlight>delete</highlight> the KDS {{kdsName}}?",
			warningText:
				"When confirmed, all linked screens and products associated with this KDS will be deleted.",
			backButton: "Back",
			confirmButton: "Confirm",
		},
		configForm: {
			kdsNameLabel: "KDS Name",
			kdsNamePlaceholder: "Describe the name of the new KDS",
			linkedBarsLabel: "Linked bar(s)",
			linkedBarsPlaceholder: "Select one or more bars to link",
			productsDisplayedLabel: "Displayed products",
			productsDisplayedDescription:
				"List of all bar products that can be displayed on this KDS.",
			emptyProductsTitle: "No products displayed yet",
			emptyProductsBullet1:
				"Register products in the linked bar for them to appear here.",
			emptyProductsBullet2: "Link this KDS to a bar to load the products.",
			goToBarsButton: "Go to bars and sectors",
			products: "products",
		},
		tabs: {
			configuration: "Configuration",
			statusAndTime: "Status & Time",
		},
		generalSettings: {
			timeManagementTitle: "Time management",
			statusUpdateTitle: "Order status update",
			cardInfoTitle: "Information displayed on the order card",
		},
		printing: {
			title: "Printing",
			toggleLabel: "Print order when marked as done",
			toggleDescription:
				"When an order is completed on this KDS, it is automatically printed on the associated printers.",
			associatedPrintersTitle: "Associated printers",
			ipLabel: "Printer IP",
			ipPlaceholder: "Enter the IP",
			nicknameLabel: "Nickname",
			nicknamePlaceholder: "Enter the printer name. E.g.: Expedition - counter",
			addPrinter: "+ Add printer",
			errors: {
				duplicateIp: "This IP is already associated with this KDS.",
			},
		},
		screensPanel: {
			configuredScreensLabel: "Configured screens",
			addScreenButton: "Add screen",
			unsavedWarningTitle: "Main KDS Not Saved",
			unsavedWarningMessage:
				"To be able to <strong>edit or add new screens</strong>, you need to <strong>save the Main KDS settings below.</strong>",
			productsLabel: "Products",
		},
		productsPreview: {
			searchPlaceholder: "Search by product or category",
			loadingMessage: "Loading products...",
			noResultsMessage: "No products found for the search.",
			noProductsMessage: "No products found for the selected bar.",
		},
		settings: {
			timeSettings: {
				timerEnabled: {
					label: "Order time stopwatch",
					description: "Counts the order time from creation until completion.",
				},
				productionTimeEnabled: {
					label: "Production time per product",
					description: "Displays the estimated preparation time for each product.",
				},
			},
			cardInfoSettings: {
				showOrderNumber: {
					label: "Order number",
					description: "Shows the unique identifier of the order.",
				},
				showOrigin: {
					label: "Origin",
					description: "Indicates where the order was placed (POS, delivery, etc.).",
				},
				showOrderTime: {
					label: "Order time",
					description: "Displays the time when the order was created",
				},
				showCustomerTable: {
					label: "Customer/Table",
					description: "Shows the customer name or table number.",
				},
				showProductionTimeCard: {
					label: "Production time per product",
					description: "Shows the estimated preparation time for each item.",
				},
				showObservation: {
					label: "Observation",
					description: "Displays additional order observations.",
				},
			},
			statusModeOptions: {
				manual: {
					label: "Manual",
					description: "Allows advancing order status manually",
				},
				automatic: {
					label: "Automatic",
					description: "Allows advancing order status after a defined time",
				},
			},
		},
		notifications: {
			kdsCreated: "KDS created successfully",
			kdsEdited: "KDS edited successfully",
			kdsDeleted: "KDS deleted successfully",
			screenDeleted: "Screen deleted successfully",
		},
	},
	report: {
		title: "Production report",
		description:
			"Track production performance, identify bottlenecks and improvement opportunities.",
		exportButton: "Export",
		exportNotification:
			"The report is being generated and will be sent to {{email}} once it's ready.",
		exportError: "Could not generate the report. Please try again.",
		tabs: {
			overview: "Overview",
			products: "Products",
			orders: "Orders",
		},
		filters: {
			kds: "Filter by KDS",
			screen: "Filter by screen",
			source: "Filter by order source",
			category: "Filter by product category",
			product: "Filter by product",
		},
		productsTable: {
			product: "Product",
			category: "Category",
			quantity: "Quantity",
			expectedTime: "Expected time",
			actualTime: "Avg. production time",
			variation: "Variation",
			empty: "No data found for the selected period.",
			error: "Error loading data. Please try again.",
		},
		ordersTable: {
			dateTime: "Date & Time",
			orderId: "Order ID",
			source: "Order Source",
			kdsName: "Received at",
			totalTime: "Total Order Time",
			finalStatus: "Final Status",
			delayed: "Delayed",
			onTime: "On Time",
			empty: "No orders in the selected period.",
			error: "Error loading data. Please try again.",
			infoText: "For more details about the orders, go to the Sales report.",
		},
		ordersFilters: {
			orderPassword: "Search by order ID",
			finalStatus: "Filter by final status",
			finalStatusDelayed: "Delayed",
			finalStatusOnTime: "On Time",
		},
		overviewPlaceholder: {
			title: "We're getting everything ready!",
			description:
				"Soon you'll be able to view charts to analyze production times, delays, etc.",
		},
	},
};
